<template>
  <div class="news-container">
    <top-nav :shrinked="true"/>
<!--    <div ref="topMenu" id="boxFixed" class="menu-top-content" :class="{'menu-fix':isFixed}">-->
<!--      <div>新闻中心</div>-->
<!--      <div class="menu-top">-->
<!--        <div class="menu-item" :class="{'menu-active':selectedIndex==index}" v-for="(item,index) in menuList" :key="index" @click="menuClick(item,index)">-->
<!--          {{item.name}}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <img class="banner page-banner" :style="isFixed?'margin-top:88px;':'margin-top:0;'" src="@/assets/news/banner.jpg">
    <div class="site-text__content ls__content">
      <h3 class="text-blue site-text__content_h3">新闻中心</h3>
    </div>
    <div class="work-content">
      <div class="work-content-left">
        <img class="work-left-text-icon" src="@/assets/news/en.png">
        <div class="work-left-jtxw" @click="menuClick(menu1.type)">
          <img src="@/assets/news/jt_icon.png">
          <div class="text-label">{{menu1.name}}</div>
        </div>
        <div class="work-right-jtxw-cate">
          <div class="work-right-jtxw-cate-item" v-for="(item,index) in menuList" :key="index" @click="menuClick(item.type)">
            <img :src="require('@/assets/news/'+item.image)">
            <p>{{item.p1}}</p>
            <p>{{item.p2}}</p>
          </div>
        </div>
      </div>
      <div class="line-middle"></div>
      <div  class="work-content-right">
        <div class="work-filter">
          <div class="work-search">
            <el-input v-model="search.title" placeholder="关键字搜索" clearable></el-input>
            <el-button style="float: right;background:rgb(109,109,109);width: 46px;" type="primary" @click="onSearch">
              <img src="@/assets/news/search.png" style="position: absolute;right: 8px;top: 5px;width: 30px;height: 30px;">
            </el-button>
          </div>
          <div class="work-search work-search-date">
            <el-date-picker
                    style="width:150px;"
                    @change="timeChange"
                    v-model="search.time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="筛选">
            </el-date-picker>
          </div>
        </div>
        <div class="work-list">
          <div v-for="(item,index) in newsList" :key="index" class="work-list-item" @click="workClick(item,index)">
            <div class="work-list-item-left">
              <img :src="item.coverImage" @error="onImageError">
            </div>
            <div class="work-list-item-right">
              <div>
                <div class="title title-line2">{{item.title}}</div>
              </div>
              <div class="desc-text ellipsis">{{item.content}}</div>
              <div>{{item.createTime}}</div>
            </div>
            <div class="work-list-item-arrow">
              <img class="work-list-item-arrow-img" src="@/assets/news/arrow.png">
            </div>
          </div>
        </div>
        <!--  分页  -->
        <div class="footer-page" style="justify-content:center;">
          <div>
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    prev-text="上一页"
                    next-text="下一页"
                    :pager-count="pagerCount"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from '@/components/base/top-nav'
import {fetchList} from '@/api/news.js'
import {formatTime, formatUrl} from '@/utils';
import errorImg from '@/assets/error.jpg';
export default {
  name: "news",
  components:{
    topNav
  },
  data() {
    return {
        search:{
          title:'',
          time:'',
          type:''
        },
      offsetTop:0,
      isFixed: false, // 标记吸顶元素是否应该被固定在页面顶部
      selectedIndex:0,
      // 1集团新闻 2媒体报道 3项目动态4商业新闻 5物业新闻
      menu1:{
        type:1,
        name:'集团新闻',
      },
      menuList:[
        {
          type:2,
          name:'媒体\n报道',
          p1:'媒体',
          p2:'报道',
          image:'0.png'
        },
        {
          type:3,
          name:'项目\n动态',
          p1:'项目',
          p2:'动态',
          image:'1.png'
        },
        {
          type:4,
          name:'商业\n新闻',
          p1:'商业',
          p2:'新闻',
          image:'2.png'
        },
        {
          type:5,
          name:'物业\n新闻',
          p1:'物业',
          p2:'新闻',
          image:'3.png'
        }
      ],
        currentPage: 1,
        pageSize: 5,
        total: 0,
      pagerCount: 5,
      workName: '',
      address: '',
      cate: '',
      newsList:[

      ]
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    // //执行下一步
    // this.$nextTick(() => {
    //   this.offsetTop = document.querySelector('#boxFixed').offsetTop //吸顶距离顶部的距离
    // })
    this.fetchData()
  },
methods: {
  onImageError(event){
    event.target.src = errorImg;
  },
  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; // 获取当前滚动位置
    this.isFixed = scrollTop > this.offsetTop ? true : false//当滚动条大于吸顶距离顶部的距离试,就加上css样式
  },
  menuClick(type){
    this.search.title = '';
    this.search.time = '';
    this.search.type = type;
    this.currentPage = 1
    this.total = 0
    this.fetchData()
  },
    fetchData(){
        let data = Object.assign(this.search,{
          current:this.currentPage,
          size: this.pageSize
        })
        fetchList(data).then(res => {
            let data = res.data;
            data.records.forEach(record =>{
                record.createTime = formatTime(record.createTime,'yyyy-MM-dd')
                if(record.coverImage){
                  record.coverImage = formatUrl(record.coverImage)
                }else{
                  record.coverImage = ''
                }
            })
            this.newsList = data.records
            this.total = data.total
        })
    },
    handleSizeChange(val) {
        this.pageSize = val
        this.fetchData()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.fetchData()
    },
    /**
     * 搜索
     */
    onSearch(){
        this.fetchData()
    },
    timeChange(){
        console.log('this.search==',JSON.stringify(this.search))
        this.fetchData()
    },
    workClick(item,index){
      const routeData = this.$router.resolve({
        path: '/ndetail', // 假设已经定义了名为NewPage的路由
        query: {
          id: item.id,
          type:item.type
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style>
  @import "../../styles/news.css";
</style>
<style lang="scss" scoped>
.work-search{
  ::v-deep .el-input__inner{
    border-radius: 0;
  }
  ::v-deep .el-button{
    border-radius: 0;
  }
  ::v-deep .el-button--primary{
    background-color: #3063A3;
    border-color: #3063A3;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #3063A3;
  }
  /* 修改日期选择器图标的CSS样式 */
  ::v-deep .el-date-editor .el-input__icon {
      /*display: none; !* 先隐藏原有图标 *!*/

   }
  ::v-deep .el-date-editor .el-input__inner{
    padding-left: 40px;
  }
  ::v-deep .el-date-editor .el-input__prefix .el-input__icon::before {
    content: '';
    width: 18px; /* 或你的图标大小 */
    height: 14px; /* 或你的图标大小 */
    /*margin-left: 5px; !* 调整位置 *!*/
    margin-top: 13px;
    display: inline-block;
    background-image: url('~@/assets/news/sx.png');
    background-size: cover; /* 或者 contain，根据需求 */
    background-position: center; /* 可选，确保图片居中 */
  }
}
</style>
